import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { graphql } from "gatsby"
import { connect } from "react-redux"
import { postJobAsking, getJobAsking } from "store/actions/job"
import { getSearchParams } from "gatsby-query-params";

import GlobalStateProvider from "context/provider"
import Layout from "components/layout"
import SEO from "components/seo"
import Hero from "components/sections/category/hero"
import Clients from "components/sections/clients"
import Demos from "components/sections/category/demos"
import Grid from "components/sections/grid"
import Breadcumbs from "components/common/breadcumbs"
import peopleImg from "content/images/people.svg"
import PrimaryCard from "components/common/primaryCard"
import docImg from "content/images/search.svg"

import fileImg from "content/images/file.svg"
import Asking from "../../components/job/asking"

const jobSearching = "https://hrflow-ai.imgix.net/labs/job-searching.png?w=350&h=350&fit=clip"
const jobScoring = "https://hrflow-ai.imgix.net/labs/talent-copilot.jpg?w=350&h=350&fit=clip"

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  margin-bottom: 2rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`

const JobAskingPage = (
  {
    data,
    postJobAsking,
    jobAskingResponse,
    getJobAsking,
    jobAsking,
  }) => {
  const { frontmatter } = data.index.edges[0].node
  const { seoTitle, useSeoTitleSuffix, useSplashScreen } = frontmatter
  const queryParams = getSearchParams()

  const globalState = {
    // if useSplashScreen=false, we skip the intro by setting isIntroDone=true
    isIntroDone: useSplashScreen ? false : true,
    // darkMode is initially disabled, a hook inside the Layout component
    // will check the user's preferences and switch to dark mode if needed
    darkMode: false,
  }

  return (
    <GlobalStateProvider initialState={globalState}>
      <Layout>
        <SEO
          frontmatter={frontmatter}
        />
        <Breadcumbs
          color="#2A7CF8"
          text="Job analysis"
          link="/job-analysis/"
          logo={fileImg}
        />
        <Hero
          content={data.hero.edges}
          color="#2A7CF8"
          resultPage={queryParams?.key}
          docs="https://developers.hrflow.ai/reference/search-jobs"
        />
        <Grid form>
          <Asking
            queryParams={queryParams}
            postJobAsking={postJobAsking} 
            response={jobAskingResponse}
            getJobAsking={getJobAsking}
            jobAsking={jobAsking}
          />
        </Grid>
        <Clients content={data.clients.edges} category />
        <Demos content={data.demos.edges}>
          <StyledGrid className="mt-2">
            <PrimaryCard
              image={jobSearching}
              color="#2A7CF8"
              title="Job searching"
              link="/job-analysis/searching/"
              subtitle="Job Listing/Marketplace Search Demo powered by HrFlow.ai Job Searching API."
              codeUrl="https://codepen.io/HrFlow/pen/xxOeGwe"
            />
            <PrimaryCard
              image={jobScoring}
              color="#2A7CF8"
              title="Talent Copilot"
              link="/job-analysis/talent-copilot/"
              subtitle="Our AI-powered Talent Copilot is designed to help your candidates, employees, or job seekers identify the most qualified job opening for them."
            />
          </StyledGrid>
        </Demos>
      </Layout>
    </GlobalStateProvider>
  )
}

JobAskingPage.propTypes = {
  data: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  jobAskingResponse: state.job.jobAskingResponse,
  jobAsking: state.job.jobAsking,
})

export default connect(mapStateToProps, { postJobAsking, getJobAsking })(JobAskingPage)

export const pageQuery = graphql`
  {
    index: allMdx(filter: { fileAbsolutePath: { regex: "/job/asking/index/" } }) {
      edges {
        node {
          frontmatter {
            seoTitle
            seoImage
            url
            description
            keywords
            useSeoTitleSuffix
            useSplashScreen
          }
        }
      }
    }
    hero: allMdx(filter: { fileAbsolutePath: { regex: "/job/asking/hero/" } }) {
      edges {
        node {
          frontmatter {
            title
            description
          }
        }
      }
    }
    clients: allMdx(filter: { fileAbsolutePath: { regex: "/home/clients/" } }) {
      edges {
        node {
          exports {
            shownItems
            clients {
              alt
              logo {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, width: 300, quality: 90, placeholder: NONE)
                }
              }
            }
          }
          frontmatter {
            title
          }
        }
      }
    }
    demos: allMdx(filter: { fileAbsolutePath: { regex: "/job/scoring/demos/" } }) {
      edges {
        node {
          frontmatter {
            label
            title
            titlePrefix
            description
          }
        }
      }
    }
  }
`